var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:('XXXX-XXXX-XXXX'),expression:"'XXXX-XXXX-XXXX'"}],ref:"campoCodigo",attrs:{"data-cy":"codigo-da-venda"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }